// DO NOT UPDATE MANUALLY: Generated from script during build time
export const VERSION = '13.2.1-beta.20260401';
